import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PREFIX, resolveUrl } from 'src/core/constants/api.constants';
import { ScheduledCallSettingsDto } from '../models/scheduled-call-settings.dto';

const SCHEDULED_CALL_SETTINGS = `${API_PREFIX}/scheduled-call-settings`;

/** Reads and stores the tenant settings of Administration > Settings > "Rescheduled Calls". */
@Injectable({ providedIn: 'root' })
export class ScheduledCallSettingsService {
  private readonly http = inject(HttpClient);

  get(): Observable<ScheduledCallSettingsDto> {
    return this.http.get<ScheduledCallSettingsDto>(resolveUrl(SCHEDULED_CALL_SETTINGS));
  }

  /** Replaces all values at once; the backend returns the accepted payload. */
  update(settings: ScheduledCallSettingsDto): Observable<ScheduledCallSettingsDto> {
    return this.http.put<ScheduledCallSettingsDto>(resolveUrl(SCHEDULED_CALL_SETTINGS), settings);
  }
}
